.page {
  max-width: 880px;
  margin: 0 auto;
  padding: 32px var(--space-5) 60px;
  background: #fff;
  color: var(--color-ink);
}

.head { margin-bottom: 24px; }

.eyebrow {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--color-ember-dark);
}

.title {
  font-family: var(--font-display);
  font-size: var(--fs-3xl);
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.1;
  margin: 6px 0 10px;
}

.updated {
  font-size: 0.78rem;
  color: var(--color-ink-soft);
  letter-spacing: 0.06em;
  margin-bottom: 12px;
}

.summary {
  margin: 0;
  font-size: var(--fs-md);
  line-height: 1.55;
  color: var(--color-ink-soft);
  max-width: 60ch;
}

.body {
  display: flex;
  flex-direction: column;
  border-top: 2px solid var(--color-ink);
  margin-top: 16px;
}

.section {
  padding: 22px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.sectionTitle {
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  margin: 0 0 10px;
}

.sectionBody {
  margin: 0 0 8px;
  font-size: 1rem;
  line-height: 1.6;
}

.list {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.98rem;
  line-height: 1.55;
}

.dl {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 6px 18px;
  margin: 6px 0 0;
  font-size: 0.98rem;
}

.dl dt {
  color: var(--color-ink-soft);
  font-weight: 700;
  letter-spacing: 0.02em;
}

.dl dd {
  margin: 0;
  color: var(--color-ink);
}

.links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.links a {
  color: var(--color-ember-dark);
  font-weight: 700;
  letter-spacing: 0.02em;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.note { color: var(--color-ink-soft); }

.foot {
  margin-top: 24px;
  font-size: 0.92rem;
  color: var(--color-ink-soft);
  line-height: 1.5;
}

@media (max-width: 768px) {
  .dl { grid-template-columns: 1fr; }
  .dl dt { margin-top: 8px; }
}
